import {getApiMetadata} from '../../helpers/api-metadata'
import {ContentType} from '../../platform/content-type'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {AddCommentRequest, IssueComment} from './contracts'

export async function apiSidePanelAddComment(body: AddCommentRequest): Promise<IssueComment> {
  const apiData = getApiMetadata('memex-comment-on-sidepanel-item-api-data')

  const {data} = await fetchJSON<AddCommentRequest, IssueComment>(apiData.url, {
    method: 'POST',
    body,
    token: apiData.token,
    contentType: ContentType.FormData,
  })

  return data
}
